import type { RatioDimApplicabilityRow } from '../../api/endpoints/ratioDimApplicability'
import { ratioDimNumOnlyNote, ratioDimDenomOnlyNote } from '../Charts/chrome/chartChrome'

/** SP-1: Returns a per-dim warning resolver for a ratio KPI.
 *  - undefined  → dim applies to both sides (or is unknown) — no warning.
 *  - string     → dim applies to one side only; warns which side stays at its total.
 */
export function ratioDimWarningFor(
  rows: RatioDimApplicabilityRow[],
): (dim: string) => string | undefined {
  const byDim = new Map(rows.map((r) => [r.dim_name, r]))
  return (dim) => {
    const r = byDim.get(dim)
    if (!r || (r.in_num && r.in_denom)) return undefined
    if (r.in_num && !r.in_denom) return ratioDimNumOnlyNote(dim, r.denom_label ?? 'the denominator')
    if (!r.in_num && r.in_denom) return ratioDimDenomOnlyNote(dim, r.num_label ?? 'the numerator')
    return undefined
  }
}
